import React from 'react'
import { Link } from 'gatsby'
import {
  Intro,
  Layout,
  Header,
  SectionTitle,
  ItemTitle,
} from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        updated={data.updated}
      >
        <Intro>
          <p>
            Use the colors classes to alter the color of font or background
            colors. Be sure to follow our{' '}
            <Link
              class="link"
              to={'/' + data.site + '/guidelines/color/design'}
            >
              color guidelines
            </Link>{' '}
            and use colors at sufficient contrast to meet accessibility
            standards. Classes for predefined gradient and transparency styles
            are included here.
          </p>
        </Intro>
        <SectionTitle>Colors</SectionTitle>
        <p>
          These utilities control CSS properties related to color and background
          color.
        </p>
        <table>
          <thead>
            <th align="left" class="token-header">
              Token
            </th>
            <th align="left">Hex</th>
            <th align="left">Font Class</th>
            <th align="left">Background Class</th>
          </thead>
          <tbody>
            {data.colors.map(color => (
              <tr>
                <td>
                  <div class={`color-swatch u-bg--${color.class}`} />
                  {color.name}
                </td>
                <td>{color.hex}</td>
                <td>
                  <code class="table__code">.u-color--{color.class}</code>
                </td>
                <td>
                  <code class="table__code">.u-bg--{color.class}</code>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <SectionTitle className="l-margin-top--xxxlarge">
          Fill Variants
        </SectionTitle>
        <ItemTitle>Solid</ItemTitle>
        <p>Use for filling objects with a single, solid color.</p>
        <table class="table">
          <thead>
            <th> </th>
            <th>Hex</th>
          </thead>
          <tbody>
            <tr>
              <td width="350px">
                <span class="color-square u-bg--primary-base"></span> Green /
                Primary / Base
              </td>
              <td>#007856</td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--secondary"></span> Green /
                Secondary
              </td>
              <td>#EAF7EF</td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--gray-lighter"></span> Gray /
                Lighter
              </td>
              <td>#EFEFEF</td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--gray-darker"></span> Gray /
                Darker
              </td>
              <td>#333333</td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--white"></span> White
              </td>
              <td>#FFFFFF</td>
            </tr>
          </tbody>
        </table>

        <ItemTitle>Gradient</ItemTitle>
        <p>
          Use for filling objects with a predefined gradient between two colors.
        </p>

        <table class="table">
          <thead>
            <th> </th>
            <th>Start</th>
            <th>Finish</th>
            <th>Class</th>
          </thead>
          <tbody>
            <tr>
              <td width="350px">
                <span class="color-square u-bg--gradient-primary-base"></span>{' '}
                Green / Primary / Base
              </td>
              <td className="showcase-table__font-values" width="175px">
                color: <strong>#18864A</strong> <br />
                x, y: <strong>0%, 0%</strong>
              </td>
              <td className="showcase-table__font-values" width="175px">
                color: <strong>#007856</strong> <br />
                x, y: <strong>100%, 100%</strong>
              </td>
              <td>
                <span class="table__code">.u-bg--gradient-primary-base</span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="color-square u-bg--gradient-gray-lighter"></span>{' '}
                Gray / Light
              </td>
              <td className="showcase-table__font-values">
                color: <strong>#EFEFEF</strong> <br />
                x, y: <strong>0%, 0%</strong>
              </td>
              <td className="showcase-table__font-values">
                color: <strong>#D7D7D7</strong> <br />
                x, y: <strong>100%, 100%</strong>
              </td>
              <td>
                <span class="table__code">.u-bg--gradient-gray-lighter</span>
              </td>
            </tr>
          </tbody>
        </table>

        <ItemTitle>Transparent</ItemTitle>
        <p>
          Use for filling objects with a single color at a predefined opacity.
        </p>

        <table class="table">
          <thead>
            <th> </th>
            <th>Hex</th>
            <th>Opacity</th>
            <th>Class</th>
          </thead>
          <tbody>
            <tr className="showcase-table__white-row">
              <td width="350px">
                <span class="color-square u-bg--transparent-primary-base-85"></span>
                Green / Primary / Base / 85%
              </td>
              <td width="175px">#007856</td>
              <td width="175px">85%</td>
              <td>
                <span class="table__code">
                  .u-bg--transparent-primary-base-85
                </span>
              </td>
            </tr>
            <tr className="showcase-table__grey-row">
              <td>
                <span class="color-square u-bg--transparent-black-15"></span>
                Black / 15%
              </td>
              <td> #000</td>
              <td> 15%</td>
              <td>
                <span class="table__code">.u-bg--transparent-black-15</span>
              </td>
            </tr>
            <tr className="showcase-table__white-row">
              <td>
                <span class="color-square u-bg--transparent-black-25"></span>
                Black / 25%
              </td>
              <td> #000</td>
              <td> 25%</td>
              <td>
                <span class="table__code">.u-bg--transparent-black-25</span>
              </td>
            </tr>
          </tbody>
        </table>

        <ItemTitle>None</ItemTitle>
        <p>Use for removing or customizing an existing fill.</p>
      </Layout>
    </>
  )
}

export const classes = {
  headings: ['Class', 'Type', 'CSS', 'Description'],
  data: [
    {
      class: '.u-flex-container',
      type: 'parent',
      css: 'display: flex',
      description: 'Used on any element to declare it as a flex element.',
    },
    {
      class: '.u-flex-align--left',
      type: 'parent',
      css: 'justify-content: flex-start',
      description: 'Distributes flex children to the left.',
    },
    {
      class: '.u-flex-align--right',
      type: 'parent',
      css: 'justify-content: flex-end',
      description: 'Distributes flex children to the right.',
    },
    {
      class: '.u-flex-align--center',
      type: 'parent',
      css: 'justify-content: middle',
      description: 'Distributes flex children to the middle.',
    },
    {
      class: '.u-flex-align--justify',
      type: 'parent',
      css: 'justify-content: space-between',
      description:
        'Distributes flex children to the left and right edges of the container.',
    },
    {
      class: '.u-flex-align--spaced',
      type: 'parent',
      css: 'justify-content: space-around',
      description: 'Distributes flex children evenly all around.',
    },
    {
      class: '.u-flex-align--top',
      type: 'parent',
      css: 'align-items: top',
      description: 'Aligns flex children to the top of container.',
    },
    {
      class: '.u-flex-align--middle',
      type: 'parent',
      css: 'align-items: center',
      description: 'Aligns flex children to the center of container.',
    },
    {
      class: '.u-flex-align--bottom',
      type: 'parent',
      css: 'align-items: bottom',
      description: 'Aligns flex children to the bottom of container.',
    },
    {
      class: '.u-flex-align--stretch',
      type: 'parent',
      css: 'align-items: stretch',
      description: 'Stretches flex children to fill the container.',
    },
    {
      class: '.u-flex-dir--row',
      type: 'parent',
      css: 'flex-direction: row',
      description:
        'All child elements will flow horizonatally from left to right.',
    },
    {
      class: '.u-flex-dir--row-reverse',
      type: 'parent',
      css: 'flex-direction: row-reverse',
      description:
        'All child elements will flow horizonatally from right to left.',
    },
    {
      class: '.u-flex-dir--column',
      type: 'parent',
      css: 'flex-direction: column',
      description:
        'All child elements will flow vertically from top to bottom.',
    },
    {
      class: '.u-flex-dir--column-reverse',
      type: 'parent',
      css: 'flex-direction: column-reverse',
      description:
        'All child elements will flow vertically from bottom to top.',
    },
    {
      class: '.u-flex-align-self--top',
      type: 'child',
      css: 'align-self: start',
      description: 'Aligns self to the top of flex parent container.',
    },
    {
      class: '.u-flex-align-self--middle',
      type: 'child',
      css: 'align-self: center',
      description: 'Aligns self to the center of flex parent container.',
    },
    {
      class: '.u-flex-align-self--bottom',
      type: 'child',
      css: 'align-self: end',
      description: 'Aligns self to the bottom of flex parent container.',
    },
    {
      class: '.u-flex-align-self--stretch',
      type: 'child',
      css: 'align-self: end',
      description: 'Stretches self to fill flex parent container.',
    },
    {
      class: '.u-flex-child--auto',
      type: 'child',
      css: 'flex: 1 1 auto',
      description: 'Element will grow and shrink as needed.',
    },
    {
      class: '.u-flex-child--grow',
      type: 'child',
      css: 'flex: 1 0 auto',
      description: 'Element will grow to fill the space of flex parent.',
    },
    {
      class: '.u-flex-child--shrink',
      type: 'child',
      css: 'flex: 0 1 auto',
      description: 'Element will shrink if necessary to fit inside of parent.',
    },
  ],
}

export const code = {
  flex: `<div class="u-flex-container"></div>
<div class="u-flex-align--left"></div>
<div class="u-flex-align--right"></div>
<div class="u-flex-align--center"></div>
<div class="u-flex-align--center-middle"></div>
<div class="u-flex-align--justify"></div>
<div class="u-flex-align--spaced"></div>
<div class="u-flex-align--top"></div>
<div class="u-flex-align--middle"></div>
<div class="u-flex-align--bottom"></div>
<div class="u-flex-align--stretch"></div>
<div class="u-flex-align-self--top"></div>
<div class="u-flex-align-self--middle"></div>
<div class="u-flex-align-self--bottom"></div>
<div class="u-flex-align-self--stretch"></div>
<div class="u-flex-child--auto"></div>
<div class="u-flex-child--grow"></div>
<div class="u-flex-child--shrink"></div>
<div class="u-flex-dir--row"></div>
<div class="u-flex-dir--row-reverse"></div>
<div class="u-flex-dir--column"></div>
<div class="u-flex-dir--column-reverse"></div>
`,
}
